type ViewerSettingSource = {
  viewer_setting?: {
    is_enabled?: boolean;
  };
};

/**
 * Whether the viewer (共有先の従業員) search field should be shown.
 * Driven solely by `viewer_setting.is_enabled` — `acl_existed` is
 * intentionally ignored so a leftover ACL sync does not re-show the field
 * once the setting has been turned off.
 */
export const shouldShowViewerField = (
  flagAxisAuth2ndApi: boolean,
  officeInvoiceReportSettings?: ViewerSettingSource
): boolean =>
  flagAxisAuth2ndApi &&
  Boolean(officeInvoiceReportSettings?.viewer_setting?.is_enabled);
